export default __webpack_public_path__ + "static/media/FP_GR.1e900dfa.png";